import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import saveAs from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription, Subject, BehaviorSubject, merge, debounceTime, distinctUntilChanged, filter, switchMap, catchError, of, map } from 'rxjs';
import { ExpressionOfInterest } from '../../../../../shared/models/ExpressionOfInterest';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Envsetting } from '../../../../../../environments/environment';



@Component({
  selector: 'app-eoi-exhibition-list',
  templateUrl: './eoi-exhibition-list.component.html',
  styleUrl: './eoi-exhibition-list.component.css'
})
export class EoiExhibitionListComponent {
  [x: string]: any;
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();
  baseUrl = Envsetting.apiBaseUrl;

  userType = sessionStorage.getItem('UserType');

  dataSource!: MatTableDataSource<ExpressionOfInterest>
  // displayedColumns: string[] = ['RowNum', 'EnterpriseCode', 'EnterpriseName', 'UdyamRegistrationNumber', 'DateOfEstablishment', 'createdDate', 'IndustrySector', 'Gender', 'District', 'OrganizationType', 'SocialCategory', 'ApplicationDownload', 'DocumentsDownload']
displayedColumns: string[] = [
  'RowNum',
    'ApplicationId',
  'registrationType',

  // 'EoiExhibitionName',
        'UdyamNumber',
    'msmEName',
        'artisanNumber' ,

  'artisanName',


  'YearOfEstablishment',
  'CreatedDate',
  'IndustrySector',

  'Gender',
  'DistrictName',
  'OrganizationTypeName',
  'SocialCategoryName',
  'ApplicationDownload',
  'DocumentsDownload'
];
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchText: string = '';
  frmEOIList: FormGroup;
  LoadGrading: any[] = [];
  allrecord: any[] = [];

  totalItems: number = 0; // Example total items

  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  length: number = 0;
  pageSize: number = 10;
  displayedData: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  loadingSequence: boolean = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  term$ = new BehaviorSubject<string>('');

  constructor(private ngxUiLoaderService: NgxUiLoaderService, private sanitizer: DomSanitizer, private dialog: MatDialog, private formBuilder: FormBuilder, private apiService: ApiService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private commonService: CommonService, private toastrService: ToastrService) {
  this.frmEOIList = this.formBuilder.group({
  registrationType: [''],
  fromDate: [''],
  toDate: [''],
  searchControl: new FormControl(
    '',
    [Validators.pattern(this.commonService.searchFilter)]
  ),
});
  }

  DtoPagination = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "createdDate",
    "SortDirection": "DESC",
    "SearchTerm": "",
    "SearchCol": "",
    "FromDate": "",
    "ToDate": "",
    "registrationType": ""
  }

  ngOnInit(): void {

    this.DtoPagination.PageNumber = 1;
    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SortColumn = "createdDate";
    this.DtoPagination.SortDirection = "DESC";
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = "";
    this.DtoPagination.FromDate = "";
    this.DtoPagination.ToDate = "";
    this.loadingSequence = true; // ⬅️ Start loader before anything begins

    this.LoadEOIRecord();

  }

  ngAfterViewInit() {
    if (!this?.sort) {
      //console.error("MatSort is not initialized!");
      return;
    }
    this.LoadEOIRecord();
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.frmEOIList.reset();
    this.DtoPagination.PageNumber = 1;
    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SortColumn = "createdDate";
    this.DtoPagination.SortDirection = "DESC";
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = "";
    this.DtoPagination.FromDate = "";
    this.DtoPagination.ToDate = "";
    this.LoadEOIRecord();
  }

  LoadEOIRecord() {
    const fromDateRaw = this.frmEOIList.get('fromDate')?.value;
    const toDateRaw = this.frmEOIList.get('toDate')?.value;

    let fromDate = '';
    let toDate = '';

    if (fromDateRaw) {
      const d = new Date(fromDateRaw);
      fromDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    if (toDateRaw) {
      const d = new Date(toDateRaw);
      toDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }

    this.loadDataSubscription.unsubscribe();

    if (!this?.sort) {
      //console.error("Error: MatSort is undefined");
      return;
    }

    this.sort?.sortChange.subscribe(() => this.pagination.pageIndex = 0);
    this.loadDataSubscription = merge(
      this.sort?.sortChange,
      this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
      this.pagination.page
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap((searchTerm) => {
          if (searchTerm) {
            this.pagination.pageIndex = 0;
          }
          this.DtoPagination.SortColumn = this.sort?.active;
          this.DtoPagination.SortDirection = this.sort?.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;
          this.DtoPagination.FromDate = fromDate;
          this.DtoPagination.ToDate = toDate;


          return this.apiService.getRequest(API_ENDPOINTS.getEoiExhibitionList, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp.status) {
            //debugger;
            this.length = resp.totalRecords;
          }
          console.log(resp.data);
          return resp.data;
        })
      ).subscribe(data => {
        this.dataSource = data;

        console.log(data);
        this.allrecord = data;
        this.adjustPaginator();
      });

  }

  

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.LoadEOIRecord();
  }

  // onSearchClick(searchValue: string): void {
  //   const searchControl = this.frmEOIList.get('searchControl');
  //   const fromDateRaw = this.frmEOIList.get('fromDate')?.value;
  //   const toDateRaw = this.frmEOIList.get('toDate')?.value;

  //   let fromDate = '';
  //   let toDate = '';

  //   if (fromDateRaw) {
  //     const d = new Date(fromDateRaw);
  //     fromDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  //   }

  //   if (toDateRaw) {
  //     const d = new Date(toDateRaw);
  //     toDate = `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  //   }

  //   if ((searchControl?.value && searchValue.trim() !== '') || (fromDate != '' && toDate != '')) {
  //     this.DtoPagination.SearchTerm = searchValue.trim();
  //     this.LoadEOIRecord();
  //   } else if (searchValue.trim() === '') {
  //     searchControl?.markAsTouched();
  //   } else {
  //     searchControl?.markAsTouched();
  //   }
  // }


onSearchClick(searchValue: string): void {

  const searchControl = this.frmEOIList.get('searchControl');

  const fromDateRaw = this.frmEOIList.get('fromDate')?.value;
  const toDateRaw = this.frmEOIList.get('toDate')?.value;

  const registrationType =
    this.frmEOIList.get('registrationType')?.value;

  let fromDate = '';
  let toDate = '';

  if (fromDateRaw) {
    const d = new Date(fromDateRaw);

    fromDate =
      `${d.getFullYear()}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${d.getDate()
        .toString()
        .padStart(2, '0')}`;
  }

  if (toDateRaw) {
    const d = new Date(toDateRaw);

    toDate =
      `${d.getFullYear()}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${d.getDate()
        .toString()
        .padStart(2, '0')}`;
  }

  // Set DTO values
  this.DtoPagination.SearchTerm = searchValue.trim();

  this.DtoPagination.FromDate = fromDate;
  this.DtoPagination.ToDate = toDate;

  this.DtoPagination.registrationType = registrationType;

  // Load data
  this.LoadEOIRecord();
}



exportToPDF(): void {

  this.loadingSequence = true;

  // ✅ Use full data instead of paginated table data
  const exportData = this.allrecord;

  // ✅ Initialize jsPDF
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4',
  });

  // ✅ Table Columns
  const columns = [

    'Sr.No',
    'Registration Type',
    'ApplicationId',
    // 'Enterprise Name',
        'Msme Name',
    'Artisan Name',

    'Udyam Number',
    'Artisan / Pehchan Card Number',
    'Year Of Establishment',
    'Submission Date',
    'Industry Sector',
    'Gender',
    'District',
    'Organization Type',
    'Social Category'


  ];

  // ✅ Table Rows (ALL DATA)
  const rows = exportData.map((item: any, index: number) => [

    index + 1,

    item.registrationType || '',

    item.ApplicationId || '',
    item.msmEName || '',

    // item.EoiExhibitionName || '',
    item.artisanName || '',

    item.udyamNumber || '',

    item.artisanNumber || '',

    item.YearOfEstablishment || '',

    this.parseDate(item.CreatedDate),

    item.registrationType === 'MSME'
      ? (
          item.industrySectorSelect === 'Other'
            ? item.industrySectorOther
            : item.industrySectorSelect
        )
      : item.IndustrySector,

    item.Gender === 'M'
      ? 'Male'
      : item.Gender === 'F'
      ? 'Female'
      : item.Gender === 'O'
      ? 'Other'
      : '',


    item.DistrictName || '',

    item.OrganizationTypeName || '',

    item.SocialCategoryName || ''

  ]);

  // ✅ Title
  doc.setFontSize(14);
  doc.text('EOI Exhibition Report', 14, 15);

  // ✅ Auto Table
  autoTable(doc, {

    head: [columns],

    body: rows,

    startY: 25,

    theme: 'striped',

    headStyles: {
      fillColor: [22, 160, 133],
      fontSize: 7
    },

    styles: {
      fontSize: 6,
      cellPadding: 2,
      overflow: 'linebreak'
    },

    alternateRowStyles: {
      fillColor: [245, 245, 245]
    },

    margin: {
      top: 20,
      left: 5,
      right: 5
    },

    columnStyles: {

      0: { cellWidth: 10 },

      1: { cellWidth: 22 },

      2: { cellWidth: 35 },

      3: { cellWidth: 35 },

      4: { cellWidth: 32 },

      5: { cellWidth: 35 },

      6: { cellWidth: 22 },

      7: { cellWidth: 25 },

      8: { cellWidth: 28 },

      9: { cellWidth: 15 },

      10: { cellWidth: 28 },

      11: { cellWidth: 28 },

      12: { cellWidth: 28 }

    }

  });

  // ✅ Save PDF
  doc.save('EOI_Exhibition.pdf');

  this.loadingSequence = false;

}
  //#endregion

  //#region My exportToExcel

  // ✅ helper to parse dates safely
  parseDate(value: any): Date | null {
    if (!value) return null;

    // If it's already a Date object
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }

    // Try direct parse
    const parsed = new Date(value);
    if (!isNaN(parsed.getTime())) {
      return parsed;
    }

    // Try dd-MM-yyyy or dd/MM/yyyy
    const parts = String(value).split(/[-/]/);
    if (parts.length === 3) {
      const [day, month, year] = parts.map(Number);
      if (year && month && day) {
        return new Date(year, month - 1, day);
      }
    }

    return null;
  }

LoadEOIRecordExcel() {

  const fromDateRaw = this.frmEOIList.get('fromDate')?.value;
  const toDateRaw = this.frmEOIList.get('toDate')?.value;

  const registrationType =
    this.frmEOIList.get('registrationType')?.value;

  let fromDate = '';
  let toDate = '';

  // ✅ Format From Date
  if (fromDateRaw) {

    const d = new Date(fromDateRaw);

    fromDate =
      `${d.getFullYear()}-` +
      `${(d.getMonth() + 1).toString().padStart(2, '0')}-` +
      `${d.getDate().toString().padStart(2, '0')}`;

  }

  // ✅ Format To Date
  if (toDateRaw) {

    const d = new Date(toDateRaw);

    toDate =
      `${d.getFullYear()}-` +
      `${(d.getMonth() + 1).toString().padStart(2, '0')}-` +
      `${d.getDate().toString().padStart(2, '0')}`;

  }

  // ✅ Prepare DTO For Excel Export
  const dtoExcel = {

    PageNumber: 1,

    PageSize: 100000, // ✅ Load All Records

    SortColumn: this.sort?.active || 'CreatedDate',

    SortDirection: this.sort?.direction || 'DESC',

    SearchTerm: this.commonService.searchText || '',

    SearchCol: this.commonService.searchText || '',

    FromDate: fromDate,

    ToDate: toDate,


    registrationType: registrationType || ''

  };

  // ✅ API Call
  this.apiService
    .getRequest(API_ENDPOINTS.getEoiExhibitionList, dtoExcel)
    .pipe(
      catchError(() => of(null))
    )
    .subscribe((resp: any) => {

      if (resp?.status) {

        console.log('Excel Export Data:', resp.data);

        // ✅ Separate Array For Excel/PDF Export
        this.allrecordExcel = resp.data || [];

        this.exportToExcel(this.allrecordExcel);

      } else {

        this.allrecordExcel = [];

      }

    });

}
allrecordExcel: any[] = [];
  exportToExcel(exportData: any[]): void {

  this.loadingSequence = true;



  const fileName = 'EOI_Exhibition_List.xlsx';

  // ✅ Use Full Data


  // ✅ Prepare Excel Data
  const excelData = exportData.map((item: any, index: number) => ({

    'Sr.No': index + 1,

    'Registration Type': item.registrationType || '',

    'EOI Exhibition Response Number': item.ApplicationId || '',

    // 'Enterprise Name': item.EoiExhibitionName || '',
    'Msme Name': item.msmEName || '',
    'Artisan Name': item.artisanName || '',

    'Udyam Number': item.udyamNumber || '',

    'Artisan / Pehchan Card Number': item.artisanNumber || '',

    'Year Of Establishment': item.YearOfEstablishment || '',

    'Submission Date': this.parseDate(item.CreatedDate),

    'Industry Sector':
      item.registrationType === 'MSME'
        ? (
            item.industrySectorSelect === 'Other'
              ? item.industrySectorOther
              : item.industrySectorSelect
          )
        : item.IndustrySector,

    'Gender':
      item.Gender === 'M'
        ? 'Male'
        : item.Gender === 'F'
        ? 'Female'
        : item.Gender === 'O'
        ? 'Other'
        : '',

    'District': item.DistrictName || '',

    'Organization Type': item.OrganizationTypeName || '',

    'Social Category': item.SocialCategoryName || ''

  }));

  // ✅ Create Worksheet
  const worksheet: XLSX.WorkSheet =
    XLSX.utils.json_to_sheet(excelData);

  // ✅ Auto Width For Columns
  const columnWidths = Object.keys(excelData[0] || {}).map((key) => ({
    wch: Math.max(
      key.length,
      ...excelData.map((row: any) =>
        row[key] ? row[key].toString().length : 0
      )
    ) + 5
  }));

  worksheet['!cols'] = columnWidths;

  // ✅ Workbook
  const workbook: XLSX.WorkBook = {
    Sheets: {
      'EOI Exhibition Report': worksheet
    },
    SheetNames: ['EOI Exhibition Report'],
  };

  // ✅ Write Excel File
  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  this.saveExcelFile(excelBuffer, fileName);

  this.loadingSequence = false;

}

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  private getValidDate(dateString: string | undefined): Date | null {
    // Check if the date string is defined and not an empty string.
    if (dateString && dateString.trim() !== '') {
      const date = new Date(dateString);
      // Use a simple check to see if the date is valid.
      if (!isNaN(date.getTime())) {
        return date;
      }
    }
    return null;
  }

  action(ApplicationId: string) {
    this.router.navigate(['/eoi-exhibition-view', ApplicationId]);
  }

  onDownload(filePath: string, fileName: string) {
    this.loadingSequence = true; // ⬅️ Start loader before anything begins
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.loadingSequence = false; // ⬅️ close loader before anything begins
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  downloadEoiExihibitionDocuments(filePath: string, applicationId: string) {

    this.apiService.downloadFile(filePath)
      .subscribe({
        next: (blob: Blob) => {

          // 🔹 Extract original extension
          const originalName = filePath.split('/').pop() || '';
          const extension = originalName.includes('.')
            ? originalName.substring(originalName.lastIndexOf('.'))
            : '';

          // 🔹 Set new file name
          const fileName = 'EOI_Exhibition_' + applicationId + extension;

          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = objectUrl;
          a.download = fileName;
          a.click();

          URL.revokeObjectURL(objectUrl);
        },
        error: (err) => {
          console.error('Download error', err);
        }
      });
  }


  downloadEoiExhibitionFile(filePath: string, applicationId: string) {

    this.apiService.downloadFile(filePath)
      .subscribe({
        next: (blob: Blob) => {

          // 🔹 Get original file extension
          const originalName = filePath.split('/').pop() || '';
          const extension = originalName.includes('.')
            ? originalName.substring(originalName.lastIndexOf('.'))
            : '';

          // 🔹 Use ApplicationId as filename
          const fileName = 'EOI_Exhibition_' + applicationId + extension;

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = url;
          a.download = fileName;
          a.click();

          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Download error', err);
        }
      });
  }
}
